import { forwardRef, Ref, SVGAttributes } from 'react';
type Props = SVGAttributes<SVGSVGElement>;
const WrongIcon = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g clipPath="url(#clip0_836_617)">
      <path d="M31.25 8.75L8.75 31.25" stroke="#D91625" strokeWidth="3.75" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M31.25 31.25L8.75 8.75" stroke="#D91625" strokeWidth="3.75" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_836_617">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>);
export default WrongIcon;